export function btnmatrix(ctx) {
    return {
        styles: {
            main: { ...ctx.pretty, radius: 5, padding: 0 },
            // item_buttons part — uses btn style
            item_buttons: {
                bg_color:     '#333333',
                border_color: '#ffffff',
                border_width: 2,
                text_color:   '#ffffff',
                text_font:    32,
                radius:       5,
            },
        },
    };
}
